/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { BookOpenTextIcon16Light } from './BookOpenTextIcon16Light';
import { BookOpenTextIcon16Regular } from './BookOpenTextIcon16Regular';
import { BookOpenTextIcon16Solid } from './BookOpenTextIcon16Solid';
import { BookOpenTextIcon20Light } from './BookOpenTextIcon20Light';
import { BookOpenTextIcon20Regular } from './BookOpenTextIcon20Regular';
import { BookOpenTextIcon20Solid } from './BookOpenTextIcon20Solid';
import { BookOpenTextIcon24Regular } from './BookOpenTextIcon24Regular';
import { BookOpenTextIcon24Solid } from './BookOpenTextIcon24Solid';
import { BookOpenTextIcon32Regular } from './BookOpenTextIcon32Regular';
import { BookOpenTextIcon64Regular } from './BookOpenTextIcon64Regular';
var sizes = {
    16: {
        light: BookOpenTextIcon16Light,
        regular: BookOpenTextIcon16Regular,
        solid: BookOpenTextIcon16Solid,
    },
    20: {
        light: BookOpenTextIcon20Light,
        regular: BookOpenTextIcon20Regular,
        solid: BookOpenTextIcon20Solid,
    },
    24: {
        regular: BookOpenTextIcon24Regular,
        solid: BookOpenTextIcon24Solid,
    },
    32: {
        regular: BookOpenTextIcon32Regular,
    },
    64: {
        regular: BookOpenTextIcon64Regular,
    },
};
export var BookOpenTextIcon = forwardRef('BookOpenTextIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
